module.exports = __webpack_public_path__ + "assets/img/943468fb94400bc3cadeb3676417aeec.svg";